import React from 'react';
import { useTranslation } from 'react-i18next';
import { CircleHelp, Info } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Switch } from '@/components/ui/switch';
import { TooltipIconButton } from '@/components/ui/tooltip-icon-button';
import SettingRow from '../SettingRow';

interface DesignVerificationSettingProps {
  enabled: boolean;
  disabled: boolean;
  canManage: boolean;
  onToggle: (next: boolean) => void;
}

const SWITCH_ID = 'admin-setting-design-verification';

const DesignVerificationSetting: React.FC<DesignVerificationSettingProps> = ({
  enabled,
  disabled,
  canManage,
  onToggle,
}) => {
  const { t } = useTranslation();

  return (
    <div>
      <SettingRow
        htmlFor={SWITCH_ID}
        disabled={disabled}
        label={t('settings.designVerification')}
        description={
          enabled
            ? t('settings.designVerificationEnabledDescription')
            : t('settings.designVerificationDisabledDescription')
        }
        control={
          <>
            <TooltipIconButton
              label={t('settings.designVerificationTooltip')}
              icon={<CircleHelp strokeWidth={1.9} />}
              size="icon-sm"
              className="size-6 text-muted-foreground"
            />
            <Switch
              id={SWITCH_ID}
              checked={enabled}
              disabled={disabled}
              onCheckedChange={onToggle}
            />
          </>
        }
      />

      {!canManage && (
        <Alert variant="info" className="mt-4">
          <Info className="h-4 w-4" />
          <AlertDescription className="revy-cjk leading-[1.6]">
            {t('settings.adminRequired')}
          </AlertDescription>
        </Alert>
      )}
    </div>
  );
};

export default DesignVerificationSetting;
